import script from "./MoleculeReorderItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeReorderItems.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeReorderItems.vue?vue&type=style&index=0&id=d3d92358&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d92358"]])

export default __exports__